import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type DisplaySettingsParams = {
  showTitle: SettingsParamType.Boolean
  showLocationTabs: SettingsParamType.Boolean
  showExperienceImage: SettingsParamType.Boolean
  showExperienceSummary: SettingsParamType.Boolean
  showExperienceDuration: SettingsParamType.Boolean
  showExperienceDate: SettingsParamType.Boolean
  showExperiencePrice: SettingsParamType.Boolean
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
  },
  showLocationTabs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
  },
  showExperienceImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showExperienceSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showExperienceDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showExperienceDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showExperiencePrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
})
